import React from "react";
import "./SocialMedia.css";
import { socialMediaLinks } from "../../portfolio";
import { trackSocialMediaClick } from "../analytics/Analytics";

export default function socialMedia() {
  return (
    <div className="social-media-div">
      <a
        href={socialMediaLinks.github}
        className="icon-button github"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackSocialMediaClick("GitHub")}
      >
        <i className="fab fa-github"></i>
        <span></span>
      </a>
      <a
        href={socialMediaLinks.linkedin}
        className="icon-button linkedin"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackSocialMediaClick("LinkedIn")}
      >
        <i className="fab fa-linkedin-in"></i>
        <span></span>
      </a>
      <a
        href={`mailto:${socialMediaLinks.gmail}`}
        className="icon-button gmail"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackSocialMediaClick("Gmail")}
      >
        <i className="fas fa-envelope"></i>
        <span></span>
      </a>
      <a
        href={socialMediaLinks.hackerrank}
        className="icon-button hackerrank"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackSocialMediaClick("HackerRank")}
      >
        <i className="fab fa-hackerrank"></i>
        <span></span>
      </a>
      <a
        href={socialMediaLinks.twitter}
        className="icon-button twitter"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackSocialMediaClick("Twitter")}
      >
        <i className="fab fa-twitter"></i>
        <span></span>
      </a>
      <a
        href={socialMediaLinks.instagram}
        className="icon-button instagram"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackSocialMediaClick("Instagram")}
      >
        <i className="fab fa-instagram"></i>
        <span></span>
      </a>
      <a
        href={socialMediaLinks.youtube}
        className="icon-button youtube"
        rel="noopener noreferrer"
        onClick={() => trackSocialMediaClick("YouTube")}
      >
        <i className="fab fa-youtube"></i>
        <span></span>
      </a>
    </div>
  );
}
